import React, { useEffect, useState } from "react";
import EmiModal from "../pages/KYC/EmiModal";
import { da } from "date-fns/locale";

function LoanDetailsCard({ data }) {
  const LoanText = ({ text }) => {
    return <p className="text-xs text-[#8b8b8b] font-medium">{text}</p>;
  };

  const LoanTableRow = ({
    leftLable,
    leftValue,
    rightLable,
    rightValue,
    styles,
    last,
  }) => {
    return (
      <div
        className={`mx-4 py-2 border-b border-[#f5f5f5] flex text-xs font-medium ${
          last && "border-b-0"
        }`}
      >
        <div className="w-[60%]">
          <LoanText text={leftLable} />
          <p
            className={`mt-1 ${
              styles ? " text-[#00394d] underline cursor-pointer" : ""
            }`}
          >
            {leftValue}
          </p>
        </div>
        <div className="w-[40%]">
          <LoanText text={rightLable} />
          <p className={`mt-1 `}>{rightValue}</p>
        </div>
      </div>
    );
  };

  const [value, setValue] = useState("");
  const [actionStatus, setActionStatus] = useState("");
  const [chunkArray, setChunkArray] = useState([]);
  function formatString(str) {
    if (str === "kyc_completed") return "KYC Completed";
    return str
      .split("_") // Split the string by underscores
      .map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Capitalize the first letter of each word
      )
      .join(" "); // Join the words with spaces
  }
  const actionKeyValue = (status) => {
    if (status === "90 DPD") return "ninety_dpd_date";
    if (status === "Market Invoke") return "market_invoke_date";
    if (status === "Revocation Initiated") return "revoke_initiated_at";
    if (status === "Revoke Completed") return "revoke_completed_on";
    if (status === "Invocation Initiated") return "invoke_initiated_at";
    if (status === "Invoke Completed") return "invoke_completed_on";

    return "--";
  };
  const [emiModal, setEmiModal] = useState(false);
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "--";
    return num.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
  }
  useEffect(() => {
    setValue(actionKeyValue(data?.loan_details.action_status.status));
    setActionStatus(data?.loan_details.action_status.status);

    setChunkArray(objectToArray(data?.timestamp_details));
  }, [data]);

  const objectToArray = (obj) => {
    let arr = [];
    for (let key in obj) {
      arr.push({
        key: key,
        value: obj[key],
      });
    }
    let pairs = [];
    for (let i = 0; i < arr.length; i = i + 2) {
      if (arr[i + 1] === undefined) {
        pairs.push([arr[i]]);
        break;
      }
      pairs.push([arr[i], arr[i + 1]]);
    }
    return pairs;
  };
  return (
    <div className=" pt-3 ">
      <div className=" flex justify-between items-center">
        <p className=" text-sm font-semibold">Loan Details</p>
        <p
          className={` rounded-[13px] px-2 py-1 text-xs  ${
            data?.loan_details.disbursed_status.status === "Disbursed"
              ? "bg-[#edfff4] text-[#0ba300]"
              : "bg-[#fff5f5] text-[#d30d00]"
          }`}
        >
          {data?.loan_details.disbursed_status.status || "--"}
        </p>
      </div>
      <div className="text-xs flex justify-between mt-3 ">
        <LoanText
          text={`Pledging date : ${
            data?.timestamp_details?.pledge_date || "--"
          }`}
        />
        <LoanText
          text={`Disbursal date :  ${
            data?.loan_details.disbursed_status.disbursal_date || "--"
          }`}
        />
      </div>
      {/* //// */}
      <div className="  mt-4  pb-1  flex  flex-col">
        <div className="flex justify-between w-full flex-col md:flex-row">
          <div className=" w-[49.6%]  border rounded border-[#e6ebed]">
            <div className="w-full h-[30px] px-4 flex items-center text-xs font-semibold bg-[#e6ebed] rounded-t-sm">
              Pledge Details
            </div>
            {/* //./ */}
            <LoanTableRow
              leftLable={"Pledged Value at time of lien mark"}
              leftValue={
                formatToIndianRupees(
                  data?.pledge_details.initial_pledged_value
                ) || "--"
              }
              rightLable={"Initial LTV"}
              rightValue={
                data?.pledge_details?.initial_ltv
                  ? data?.pledge_details.initial_ltv + " %"
                  : "--"
              }
            />
            <LoanTableRow
              leftLable={"Outstanding/OD Limit"}
              leftValue={
                data?.pledge_details.outstanding_limit !== null
                  ? formatToIndianRupees(data?.pledge_details.outstanding_limit)
                  : "--"
              }
              rightLable={"Loan Margin Ratio"}
              rightValue={
                data?.pledge_details?.loan_margin_ratio
                  ? data?.pledge_details.loan_margin_ratio + " %"
                  : "--"
              }
            />
            <LoanTableRow
              leftLable={"CAMS Pledge Ref no"}
              leftValue={data?.pledge_details.cams_pledge_ref_no || "--"}
              rightLable={"KFintech Ref no."}
              rightValue={data?.pledge_details.kfin_pledge_ref_no || "--"}
            />
            <LoanTableRow
              leftLable={"MFCentral Pledge Ref no"}
              leftValue={data?.pledge_details.mfc_pledge_ref_no || "--"}
              rightLable={"NSDL Pledge Ref no."}
              rightValue={data?.pledge_details.nsdl_pledge_ref_no || "--"}
              last={true}
            />
          </div>
          <div className=" w-[49.6%]  border rounded border-[#e6ebed]">
            <div className="w-full h-[30px] px-4 flex items-center text-xs font-semibold bg-[#e6ebed] rounded-t-sm">
              Loan Action Details
            </div>
            {/* //./ */}
            <LoanTableRow
              leftLable={"Current Pledged Value"}
              leftValue={
                formatToIndianRupees(
                  data?.loan_action_details.current_pledged_value
                ) || "--"
              }
              rightLable={"Current Margin Ratio"}
              rightValue={`${
                data?.loan_action_details?.current_margin_ratio
                  ? (data?.loan_action_details?.current_margin_ratio).toFixed(2)
                  : "--"
              }% of outstanding loan value `}
            />
            <LoanTableRow
              leftLable={"Margin call if pledge value drops "}
              leftValue={`< ${formatToIndianRupees(
                data?.loan_action_details.margin_call_pledge_value
              )}`}
              rightLable={"Margin Ratio-Margin Call"}
              rightValue={`${
                data?.loan_action_details?.margin_call_ratio
                  ? (data?.loan_action_details?.margin_call_ratio).toFixed(0)
                  : "--"
              }% `}
            />
            <LoanTableRow
              leftLable={"Invoke if pledge value drops"}
              leftValue={`< ${formatToIndianRupees(
                data?.loan_action_details.margin_invoke_pledge_value
              )}`}
              rightLable={"Market Ratio- Market Invoke"}
              rightValue={data?.loan_action_details.invoke_ratio + "%" || "--"}
              last={true}
            />
            {/* <LoanTableRow
              leftLable={"Margin Value"}
              leftValue={
                formatToIndianRupees(data?.loan_action_details.margin_value) ||
                "--"
              }
              rightLable={"Invoke At"}
              rightValue={
                formatToIndianRupees(data?.loan_action_details.invoke_at) ||
                "--"
              }
              last={true}
            /> */}
          </div>
        </div>
        <div className="flex justify-between w-full mt-2 flex-col md:flex-row">
          <div className=" w-[49.6%]  border rounded border-[#e6ebed]">
            <div className="w-full h-[30px] px-4 flex items-center text-xs font-semibold bg-[#e6ebed] rounded-t-sm">
              Loan Details
            </div>
            {/* //./ */}
            <LoanTableRow
              leftLable={"Current Outstanding"}
              leftValue={
                data?.loan_details.current_outstanding != null
                  ? formatToIndianRupees(data?.loan_details.current_outstanding)
                  : "--"
              }
              rightLable={"Loan Amount"}
              rightValue={
                formatToIndianRupees(data?.loan_details.loan_amount) || "--"
              }
            />
            <LoanTableRow
              leftLable={"Interest Amount"}
              leftValue={
                formatToIndianRupees(
                  data?.loan_details?.interest_amount
                    ? Math.abs(data.loan_details.interest_amount)
                    : 0
                ) || "--"
              }
              rightLable={"Fees"}
              rightValue={formatToIndianRupees(data?.loan_details.fees) || "--"}
            />
            <LoanTableRow
              leftLable={"Disbursed Loan Amount"}
              leftValue={
                formatToIndianRupees(
                  data?.loan_details.disbursed_loan_amount
                ) || "--"
              }
              rightLable={"Disbursal Date"}
              rightValue={data?.loan_details.disbursal_date || "--"}
            />
            <LoanTableRow
              leftLable={"Tenure"}
              leftValue={
                data?.loan_details.tenure
                  ? data?.loan_details.tenure + " M"
                  : "--"
              }
              rightLable={"Mandate Type"}
              rightValue={data?.loan_details.mandate_type || "--"}
            />
            <LoanTableRow
              leftLable={"Account Number"}
              leftValue={data?.loan_details.account_number || "--"}
              rightLable={"IFSC Code"}
              rightValue={data?.loan_details.ifsc_code || "--"}
            />
            <LoanTableRow
              leftLable={"EMI Amount"}
              leftValue={formatToIndianRupees(data?.monthly_emi_amount) || "--"}
              rightLable={"EMI Start date"}
              rightValue={data?.emi_start_date || "--"}
              last={true}
            />
          </div>
          <div className=" w-[49.6%]  border rounded border-[#e6ebed]">
            <div className="w-full h-[30px] px-4 flex items-center text-xs font-semibold bg-[#e6ebed] rounded-t-sm">
              Timestamp Details
            </div>
            {/* //./ */}
            {chunkArray.map((item, index) => {
              return (
                <LoanTableRow
                  key={index}
                  leftLable={formatString(item[0]?.key)}
                  leftValue={item[0]?.value || "--"}
                  rightLable={item[1]?.key ? formatString(item[1]?.key) : ""}
                  rightValue={item[1]?.value || ""}
                />
              );
            })}
            {/* <LoanTableRow
              leftLable={"KYC Completed"}
              leftValue={data?.timestamp_details?.kyc_completed || "--"}
              rightLable={"Pledge Date"}
              rightValue={data?.timestamp_details?.pledge_date || "--"}
            /> */}

            {Object.values(
              data?.successful_emis ? data?.successful_emis?.emis : {}
            ).length > 0 && (
              <div className="mx-4 py-2 border-b border-[#f5f5f5] flex text-xs font-medium">
                <div className="w-[60%]">
                  <LoanText text={"Successful EMIs"} />
                  <button
                    className={`mt-1 text-[#00394d] underline cursor-pointer`}
                    onClick={() => setEmiModal(true)}
                  >
                    Click here
                  </button>
                </div>
                <div className="w-[40%]">
                  <LoanText text={"Last EMI Date"} />
                  <p className={`mt-1 `}>
                    {data?.successful_emis.last_emi_date}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {emiModal && (
        <EmiModal setEMI={setEmiModal} data={data?.successful_emis?.emis} />
      )}
    </div>
  );
}

export default LoanDetailsCard;
